{}module.exports = (typeof window === 'undefined' ? {} : window).env = {
    profile: 'onprem',
    urlSchemaWa: 'saaspassop-wa', // web to mobile app call url schema*
    userLandingPage: 'user.applications', // landing page for end user portal (after login)*
    clientDownloadUrl: {
        base: 'https://www.mycloudpass.com/#/downloads',
		mac: 'https://www.saaspass.com/desktop/osx/SAASPASS.dmg',
		windows7: 'https://cdn.saaspass.com/releases/onprem/desktop/win/SAASPASS.msi',
		windows8: 'https://cdn.saaspass.com/releases/onprem/desktop/win/SAASPASS.msi',
		ios: 'https://apps.apple.com/th/app/saaspass-on-premise/id1459089608',
		android: 'https://play.google.com/store/apps/details?id=com.solidpass.saaspass.onprem',
        radiusServer: 'https://cdn.saaspass.com/releases/onprem/assets/SAASPASSRadiusServer.msi',
        adagent: 'https://cdn.saaspass.com/releases/onprem/assets/AD/SAASPASSADAgent.msi',
        chromeExtension: 'https://cdn.saaspass.com/releases/onprem/assets/mycloudpass/mycloudpass-chrome-extension.zip'
	},
    captcha: {
        key: '6LcIvgETAAAAAIMCwRem9WxT0UvUPk_3209UrzDJ',
        maxFailedAttempts: 50,
    },
    extensionIds: {
        chrome: 'nhhldecdfagpbfggphklkaeiocfnaafm',
        opera: 'jnlcnnodlcecoagnkiplcbmpnemcibnj',
    },
    facebookAppId: '565837326835543',
  publicPath: '',
    urls: {
        customAppWidgetIframePrefix: './sd/',
        premiumIconPrefix: './',
        samlAppLogo: (slug, type = 'logo') => `https://www.mycloudpass.com/scdn/apps/${slug}/images/${type}.png`,
        minoCdn: 'https://www.mycloudpass.com/scdn/',
    },
    websocket: {
      url: 'wss://www.mycloudpass.com/ws',
    },
};


// WEBPACK FOOTER //
// ./var/tmp/onprem/env.mycloudpass.js